<script setup>
// imports
import {reactive, ref} from "vue";
import {modalStore} from "../stores/ModalStore";

// props
const props = defineProps({
    service: Object,
    category: String
});

// emits
defineEmits(["addToCart"])

//defineEmits(["addToWishlist"])

// data
const count = ref(0);
const serviceImage = props.service.image ?
    "/images/" + props.service.imagedir + props.service.image + "?w=450&h=450&fit=crop"
    : "/img/no-picture.jpg";

const imageSource = reactive({path: serviceImage});

function showImage2() {
    if (props.service.image2) {
        imageSource.path = "/images/" + props.service.imagedir2
            + props.service.image2 + "?w=450&h=450&fit=crop";
    }
}

function openModal() {
    history.pushState(null, null, '/add-services/detail/' + props.service.slug);
    modalStore.setIsOpened(true);
    modalStore.setService(props.service);
    modalStore.setCategory(props.category);
}

/**
 * Shows the article image.
 *
 * @return {type} description of return value
 */
function showImage() {
    imageSource.path = serviceImage;
}

</script>
<template>
    <div class="col-lg-3 col-md-4 col-6 pe-3 ps-3 mb-4">
        <div class="card article">
            <div class="article-name">
                <span class="align-middle">{{ service.name }}</span><br>
                <span v-if="service.work_package" class="">Arbeitspaket / {{ service.work_package_label }}</span>
                <span v-else-if="service.extracharge || service.dailyrate || service.hourlyrate ">Stunden / Tag</span>
            </div>
            <div class=" position-relative">
                <img :src="imageSource.path"
                     width="450"
                     height="450"
                     class="img-fluid position-relative"
                     loading="lazy"
                     @mouseover="showImage2"
                     @mouseout="showImage"
                     @click="openModal()"
                />
            </div>
            <div class="row">
                <div class="small col-12 col-md-10">
                    <span v-if="service.hourlyrate"><strong>Stundensatz {{ service.hourlyrate.name }}:
                        {{ service.hourlyrate.rate }} CHF
                    </strong><br></span>
                    <span v-if="service.dailyrate"><strong>Tagessatz {{ service.dailyrate.name }}:
                        {{ service.hourlyrate.rate }} CHF
                    </strong><br></span>
                    <span v-if="service.extracharge"><strong>{{ service.extracharge.name }}:
                        Faktor {{ service.extracharge.factor }}</strong></span>
                    <span v-if="service.price"><strong>Siehe Beispiel<br>{{ service.price }} CHF</strong></span>
                </div>
                <div class="pt-1 col-12 col-md-2 text-end">
                    <svg class="bi flex-shrink-0 ms-2 me-1" width="18" height="18" role="button"
                         aria-label="Warenkorb" title="zum Warenkorb hinzufügen"
                         @click="$emit('addToCart', 1)">
                        <use xlink:href="#icon-basket"/>
                    </svg>
                    <!--
                    <svg class="bi flex-shrink-0 me-1" width="18" height="18" role="button"
                                             aria-label="Wunschliste">
                                            <use xlink:href="#icon-wishlist"/>
                                        </svg>
                                        -->
                </div>
            </div>
        </div>
    </div>

</template>
<style scoped>
img {
    cursor: pointer;
}
</style>
